module.exports = __webpack_public_path__ + "img/arrow-right.7dbce7af.svg";